import { jsx as _jsx } from "react/jsx-runtime";
import { useIwaContext } from '@cognitranlimited/itis-web';
import React from 'react';
import logo from './brp-logo.svg';
import './BRPLogo.css';
export var BRPLogo = function () {
    var strings = useIwaContext().strings;
    return _jsx("img", { className: "BRPLogo", src: logo, alt: strings.app.name });
};
